<template>
  <div class="help-details" :style="{backgroundImage: pageObj.banner_image?`url(${pageObj.banner_image})`:'url(/images/help/bg.jpg)'}">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="help-search">
            <h2>{{ _T('How we can help you?') }}</h2>
            <div class="default-form">
              <div class="form-group mb-0">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="_T('Search for anything')"
                  v-model="searchText"
                />
                <img
                  src="images/svg/global/search.svg"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FaqBanner',
  computed: {
    ...mapGetters(['_T']),
  },
  props: ['pageObj'],
  data: () => ({
    searchText: ''
  }),
  watch: {
    searchText: function(newVal) {
      this.$parent.searchText = newVal
    }
  }
}
</script>

<style lang="scss" scoped>
.help-details {
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: auto;
  align-items: center;
  .help-search {
    text-align: center;
    margin-top: $px112;
    margin-bottom: $px112;
    h2 {
      line-height: calc(
        #{$px22} + (38 - 22) * ((100vw - #{$px320}) / (1920 - 320))
      );
      color: $white;
      font-weight: 600;
      text-transform: inherit;
      margin-bottom: calc(
        #{$px20} + (50 - 20) * ((100vw - #{$px320}) / (1920 - 320))
      );
    }
    .default-form {
      .form-group {
        position: relative;
        input {
          width: 51%;
          margin: 0 auto;
          padding-left: $px54;
          color: $font-color;
          font-weight: normal;
          &::placeholder {
            font-size: $px14;
            color: $font-color;
            font-weight: normal;
          }
        }
        img {
          position: absolute;
          left: 26%;
          top: 28%;
        }
      }
    }
  }
}
</style>
